export * from './attributesDossier.component';
export * from './attributesDossier.service';
